import {Component, Input,OnInit,ChangeDetectorRef} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { tap } from 'rxjs/operators';
import { TenderComponent } from 'src/app/modules/custom-landing/tender/tender.component';
import { NgFor } from '@angular/common';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-tender-details-modal',
    templateUrl: './tender-details-modal.component.html',
    styleUrls: ['./tender-details-modal.component.scss'],
    imports: [NgFor, I18nModule]
})
export class TenderDetailsModalComponent implements OnInit {
  @Input() code: any;
  tenderDetailsData:any;
  constructor( public activeModal: NgbActiveModal){ 
  }
  ngOnInit(): void {
    this.tenderDetailsData=this.code;
  }

}